import { render, staticRenderFns } from "./TablePricing.vue?vue&type=template&id=6607b158&scoped=true&"
import script from "./TablePricing.vue?vue&type=script&lang=js&"
export * from "./TablePricing.vue?vue&type=script&lang=js&"
import style0 from "./TablePricing.vue?vue&type=style&index=0&id=6607b158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607b158",
  null
  
)

export default component.exports